import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "../../../tailwind.config.js";
export type { ColorName } from "./colorNames";
const fullConfig = resolveConfig(tailwindConfig);

// Colors can be in one of two formats
// { "color-name": "color-value" }
// or
// { "color-name": { "color-intensity": "color-value" } }
export const Colors = fullConfig.theme.colors;

export type FontSize = keyof typeof fullConfig.theme.fontSize;

type Color = { [key: string]: string | ColorObject };
type ColorName = keyof NonNullable<Color>;
type ColorObject = { [key: number | string]: string };

const mapColor = ([key, value]: [
  key: ColorName,
  value: ColorObject | string
]) => {
  if (typeof value == "string") {
    return { [key]: value };
  }
  return mapColorObj(key, value);
};
const mapColorObj = (
  colorName: ColorName,
  colorObj: ColorObject
): { [key: string]: string } =>
  Object.entries(colorObj).reduce(
    (o, [value, colour]) => ({ ...o, [`${colorName}-${value}`]: colour }),
    {}
  );

const colorMap = Object.entries(Colors).reduce(
  (o: NotTypedYet, entry: [key: ColorName, value: string | NotTypedYet]) => ({
    ...o,
    ...mapColor(entry),
  }),
  {}
);

export default {
  ...fullConfig.theme,
  colorMap,
};
